import Axios, { AxiosInstance } from "axios";

export interface AppFiguresClientOptions {
  baseURL: string;
  apiKey?: string; // Personal Access Token (Bearer)
  publicKey?: string; // Client key (fallback)
  privateKey?: string; // Secret key (fallback)
}

export class AppFiguresClient {
  private readonly http: AxiosInstance;

  constructor(options: AppFiguresClientOptions) {
    const headers: Record<string, string> = { Accept: "application/json" };
    if (options.apiKey) {
      headers.Authorization = `Bearer ${options.apiKey}`;
    }
    this.http = Axios.create({ baseURL: options.baseURL, headers });
  }

  // Endpoints reais da API AppFigures
  async getRevenue(params: {
    start_date: string;
    end_date: string;
    products?: string;
    countries?: string;
    group_by?: string;
    platforms?: string;
  }) {
    return (await this.http.get("/reports/revenue", { params })).data;
  }

  async getSubscriptions(params: {
    start_date: string;
    end_date: string;
    products?: string;
    countries?: string;
    granularity?: string;
    group_by?: string;
    include_inapps?: boolean;
  }) {
    return (await this.http.get("/reports/subscriptions", { params })).data;
  }

  async getSales(params: {
    start_date: string;
    end_date: string;
    products?: string;
    countries?: string;
    granularity?: string;
  }) {
    return (await this.http.get("/reports/sales", { params })).data;
  }

  async getUsage(params: {
    start_date: string;
    end_date: string;
    products?: string;
    countries?: string;
    granularity?: string;
    group_by?: string;
    storefront?: string;
    networks?: string;
  }) {
    return (await this.http.get("/reports/usage", { params })).data;
  }

  async getRatings(params: {
    start_date: string;
    end_date: string;
    products?: string;
    countries?: string;
  }) {
    return (await this.http.get("/reports/ratings", { params })).data;
  }

  async getProducts(params?: {
    store?: string;
    include_inactive?: boolean;
  }) {
    return (await this.http.get("/products/mine", { params })).data;
  }
}

export function createAppFiguresClient(): AppFiguresClient {
  const useProxy = (import.meta.env.VITE_USE_APPFIGURES_PROXY as string) === "true";
  const baseURL = useProxy
    ? "/appfigures"
    : ((import.meta.env.VITE_APPFIGURES_BASE_URL as string) || "https://api.appfigures.com/v2");
  const apiKey = (import.meta.env.VITE_APPFIGURES_API_KEY as string) || undefined;
  return new AppFiguresClient({ baseURL, apiKey });
}

